import { FiMessageCircle, FiMapPin, FiTrendingUp, FiCoffee, FiLayers, FiStar, FiSun, FiAnchor, FiMap, FiActivity, FiZap, FiHeart, FiCompass, FiShield, FiBookOpen, FiFeather } from 'react-icons/fi';
import { FaRegLightbulb } from 'react-icons/fa';

export const challengesData = [
  {
    id: 1,
    title: "Common Ground",
    icon: FiLayers,
    prompt: "What's a TV show or movie franchise you've been obsessed with lately?",
    reflection: "Take a second to notice the spark of recognition when you find shared interests. How does finding 'common ground' change the energy of the conversation?",
    gradient: "bg-gradient-to-br from-blue-400 to-blue-500"
  },
  {
    id: 2,
    title: "Local Guide",
    icon: FiMapPin,
    prompt: "I'm looking for a new favorite spot—what's your #1 recommendation for coffee or food around here?",
    reflection: "Asking for a recommendation shows you value their perspective. Notice how it feels to let someone else be the expert for a moment.",
    gradient: "bg-gradient-to-br from-teal-400 to-emerald-500"
  },
  {
    id: 3,
    title: "Future Goals",
    icon: FiTrendingUp,
    prompt: "What are you most excited to achieve or get involved with this semester?",
    reflection: "Sharing aspirations can be energizing. How did it feel to voice your goals or hear someone else's drive?",
    gradient: "bg-gradient-to-br from-indigo-400 to-purple-500"
  },
  {
    id: 4,
    title: "Sensory Memory",
    icon: FiCoffee,
    prompt: "If you could eat one meal again for the first time, what would it be?",
    reflection: "Food memories are deeply personal. Did you notice a shift in mood while discussing something purely enjoyable?",
    gradient: "bg-gradient-to-br from-amber-400 to-orange-500"
  },
  {
    id: 5,
    title: "Hidden Talent",
    icon: FiStar,
    prompt: "Do you have a random or 'useless' talent that always surprises people?",
    reflection: "Vulnerability, even in small doses, builds trust. Acknowledge the courage it took to share a quirk about yourself.",
    gradient: "bg-gradient-to-br from-rose-400 to-pink-500"
  },
  {
    id: 6,
    title: "Current Vibe",
    icon: FiActivity,
    prompt: "What song or artist have you had on repeat for the last few days?",
    reflection: "People may select music that matches or shapes their mood, identity and social group. What have you noticed with this brief conversation about music preferences?",
    gradient: "bg-gradient-to-br from-cyan-400 to-blue-500"
  },
  {
    id: 7,
    title: "Wanderlust",
    icon: FiCompass,
    prompt: "If you could hop on a plane to anywhere in the world right now, where would you go?",
    reflection: "Travel dreams often reflect our values. What did their choice tell you about what they find important or exciting?",
    gradient: "bg-gradient-to-br from-emerald-400 to-teal-500"
  },
  {
    id: 8,
    title: "Ideal Day",
    icon: FiSun,
    prompt: "How does your perfect, no-plans Sunday look from start to finish?",
    reflection: "Rest is important. Notice how your body feels when talking about rest.",
    gradient: "bg-gradient-to-br from-yellow-400 to-amber-500"
  },
  {
    id: 9,
    title: "Identity Story",
    icon: FiAnchor,
    prompt: "Is there a specific story behind your name, or maybe a nickname you've had forever?",
    reflection: "Names are central to identity. How does it feel to hear the history behind something so fundamental to a person?",
    gradient: "bg-gradient-to-br from-blue-500 to-indigo-600"
  },
  {
    id: 10,
    title: "Comfort Zone",
    icon: FiHeart,
    prompt: "What's your go-to way to de-stress when things get a bit overwhelming?",
    reflection: "Acknowledge the mutual support in this moment. We all have ways of coping; sharing them creates a sense of shared humanity.",
    gradient: "bg-gradient-to-br from-pink-400 to-rose-500"
  },
  {
    id: 11,
    title: "Surprise Fact",
    icon: FiZap,
    prompt: "What's something about you that most people wouldn't guess at first glance?",
    reflection: "Breaking first impressions is a powerful way to connect. How did it feel to be seen for something deeper than the surface?",
    gradient: "bg-gradient-to-br from-violet-400 to-purple-500"
  },
  {
    id: 12,
    title: "High Note",
    icon: FaRegLightbulb,
    prompt: "What's been the absolute highlight of your week so far, no matter how small?",
    reflection: "Gratitude is contagious. Notice if focusing on a 'high note' lifted the overall mood of your interaction.",
    gradient: "bg-gradient-to-br from-yellow-500 to-orange-400"
  },
  {
    id: 13,
    title: "Curiosity",
    icon: FiBookOpen,
    prompt: "Is there a skill or hobby you've always wanted to learn but haven't started yet?",
    reflection: "Curiosity keeps us growing. Acknowledge the effort it takes to stay open to new possibilities and shared interests.",
    gradient: "bg-gradient-to-br from-sky-400 to-cyan-500"
  },
  {
    id: 14,
    title: "Brave Moment",
    icon: FiShield,
    prompt: "When was the last time you tried something that actually made you a bit nervous?",
    reflection: "Courage isn't the absence of fear. How did it feel to bond over the experience of being 'brave' together?",
    gradient: "bg-gradient-to-br from-lime-400 to-green-500"
  },
  {
    id: 15,
    title: "Perspective",
    icon: FiMessageCircle,
    prompt: "If you could give your younger self one piece of advice, what would it be?",
    reflection: "Wisdom comes from lived experience. Notice the depth of connection that comes from sharing a life lesson.",
    gradient: "bg-gradient-to-br from-slate-500 to-slate-600"
  },
  {
    id: 16,
    title: "Tactile Joy",
    icon: FiFeather,
    prompt: "Do you have any hobbies that don't involve a screen, like reading, sports, or making things?",
    reflection: "In a digital world, physical hobbies ground us. How did it feel to connect over real-world interests?",
    gradient: "bg-gradient-to-br from-fuchsia-400 to-purple-500"
  }
];